<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import {
    getStatusIcon,
    getStatusLabel,
    getStatusTone,
    isStatusAnimated,
} from '@/composables/useActivityLabels';
import type {
    ActivityStatus,
    ActivityType,
} from '@/composables/useActivityLabels';

const props = defineProps<{
    status: ActivityStatus;
    type?: ActivityType;
}>();

const icon = getStatusIcon(props.status);
const label = getStatusLabel(props.status, props.type);
const tone = getStatusTone(props.status);
const animated = isStatusAnimated(props.status);
</script>

<template>
    <Badge :variant="tone" class="gap-1.5 capitalize">
        <component
            :is="icon"
            :class="['h-3 w-3', { 'animate-spin': animated }]"
        />
        {{ label }}
    </Badge>
</template>
